import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import CompanyService from 'services/company2';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import EnumService from 'services/enum2';
import OrderService from 'services/order';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import CommonFns from 'functions/common.ts';
import Download from 'components/download.js';
import Http from 'services/http2';
import Big from 'big.js';
import PaymentService from 'services/payment';
import ModalService from 'services/modal';
//单头自定义字段
import HeadCustField from 'components/headCustField';
//单身自定义字段
import BodydCustField from 'components/bodyCustField';

function PaymentDetail(props) {
  const Config = {
    purchase: {
      title: '付款单详情',
      apiPath: '/receiptOrder/getDetail',
      auditApiPath: '/receiptOrder/audit',
      customerNameKey: 'companyName',
      companyCodeKey: 'companyCode',
      vendorNameKey: 'innerVendorName',
      arrEnumField: [
        {
          mainKey: 'B02_ReceiptOrder_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Pay_Status',
          subKey: 'payStatus',
          value: 'payStatusName'
        },
        {
          mainKey: 'B02_Order_Sync_Status',
          subKey: 'syncStatus',
          value: 'syncStatusName'
        }
      ],
      idField: 'rcpXkNo',
      custFieldBillType: 64, //自定义字段单别
      wfmCode: '1012'
    }
  };

  const SourceTypeData = [
    {
      id: 1,
      text: '对账单'
    },
    {
      id: 2,
      text: '发票单'
    },
    {
      id: 3,
      text: '付款申请'
    },
    {
      id: 4,
      text: '提前付款申请'
    },
    {
      id: 5,
      text: '预付款单'
    }
  ];

  const { state, dispatch } = useContext(ActionContext);
  const config = Config[props.type];
  config.dispatch = dispatch;

  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    decimalPlace,
    fileList,
    setShowLoading,
    setFileList,
    detail,
    setDetail,
    workflow,
    forceUpdate,
    fieldSetting,
    self
  } = useDetail(props, config);

  const [boxState, setBoxState] = useState({
    1: true
  });
  const [list, setList] = useState([]);

  //处理详情数据
  self.afterGetDetail = function (data) {
    data.lineList.forEach(item => {
      item.sourceTypeName = SourceTypeData.filter(
        type => type.id === item.sourceType
      )[0].text;
    });
    setDetail(data);
  };

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  // function handleBoxState(idx) {
  //   boxState[idx] = !boxState[idx];
  //   setBoxState(boxState);
  //   forceUpdate();
  // }

  //发送
  function audit() {
    if (Util.isEmpty(detail.paymentBankName)) {
      ModalService.showError('付款银行不能为空！', dispatch);
      return;
    }
    if (Util.isEmpty(detail.paymentBankCardNo)) {
      ModalService.showError('付款账号不能为空！', dispatch);
      return;
    }
    let postbody = getPostbody(config.auditApiPath);
    // 添加付款信息
    postbody['realPaymentMethodCode'] = detail.realPaymentMethodCode;
    postbody['realPaymentMethodName'] = detail.realPaymentMethodName;
    postbody['paymentBankCode'] = detail.paymentBankCode;
    postbody['paymentBankName'] = detail.paymentBankName;
    postbody['paymentBankCardNo'] = detail.paymentBankCardNo;
    PaymentService.auditReceiptOrder(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //审核不通过付款单（退回）
  function auditReturn() {
    let postbody = getPostbody(config.auditApiPath);
    PaymentService.returnReceiptOrder(
      postbody,
      () => {
        dispatch({ type: 'hideReject' });
        self.getDetail();
      },
      dispatch
    );
  }

  //获取提交参数
  function getPostbody(apiPath) {
    let postbody = {
      rcpXkNo: self.id,
      companyCode: companyCode,
      apiPath: apiPath
    };
    return postbody;
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      <div className="m-details-container">
        <div className="m-details-item">
          <div className="details-item-title">
            <label>基础信息</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                {self.isPurchase && (
                  <li>
                    <span className="field-label">采购方</span>
                    <div className="field-value">{detail.companyName}</div>
                  </li>
                )}
                {!self.isPurchase && (
                  <li>
                    <span className="field-label">客户名称</span>
                    <div className="field-value">
                      {detail[config.vendorNameKey]}
                    </div>
                  </li>
                )}
                <li>
                  <span className="field-label">供应商</span>
                  <div className="field-value">
                    {detail.innerVendorName}({detail.innerVendorCode})
                  </div>
                </li>
                <li>
                  <span className="field-label">付款单号</span>
                  <div className="field-value">{detail.rcpXkNo}</div>
                </li>
                {
                  <li>
                    <span className="field-label">发布人</span>
                    <div className="field-value">{detail.publishName}</div>
                  </li>
                }
                <li>
                  <span className="field-label">币别</span>
                  <div>{detail.currencyName}</div>
                </li>
                <li>
                  <span className="field-label">申请金额</span>
                  <div className="field-value">
                    {formatNumber(detail.applyTotalAmount, decimalPlace.AMOUNT)}
                  </div>
                </li>
                <li>
                  <span className="field-label">实际付款</span>
                  <div className="field-value">
                    {formatNumber(detail.realTotalAmount, decimalPlace.AMOUNT)}
                  </div>
                </li>
                {!self.isPurchase && (
                  <li>
                    <span className="field-label">纳税人识别号</span>
                    <div className="field-value">{detail.vendorCreditCode}</div>
                  </li>
                )}
                <li>
                  <span className="field-label">开户行</span>
                  <div className="field-value">{detail.bankName}</div>
                </li>
                {self.isPurchase && (
                  <li>
                    <span className="field-label">银行账号</span>
                    <div className="field-value">{detail.bankCardNo}</div>
                  </li>
                )}

                <li>
                  <span className="field-label">支付方式</span>
                  <div className="field-value">
                    {detail.applyPaymentMethodName}
                  </div>
                </li>

                <li>
                  <span className="field-label">付款银行</span>
                  <div className="field-value">{detail.paymentBankName}</div>
                </li>

                <li>
                  <span className="field-label">付款账号</span>
                  <div className="field-value">{detail.paymentBankCardNo}</div>
                </li>

                <li>
                  <span className="field-label">状态</span>
                  <div className="field-value">
                    <span
                      className={
                        'u-sign ' +
                        CommonFns.getStatusClass('rcp', detail.status)
                      }
                    >
                      {detail.statusName}
                    </span>
                  </div>
                </li>

                <li>
                  <span className="field-label">支付状态</span>
                  <div className="field-value">
                    <span
                      className={
                        'u-sign ' +
                        CommonFns.getStatusClass('bool', detail.payStatus)
                      }
                    >
                      {detail.payStatusName}
                    </span>
                  </div>
                </li>

                <li>
                  <span className="field-label">同步状态</span>
                  <div className="field-value">
                    <span
                      className={
                        'u-sign ' +
                        CommonFns.getStatusClass('sync', detail.syncStatus)
                      }
                    >
                      {detail.syncStatusName}
                    </span>
                  </div>
                </li>

                {/* 审批流状态 仅开启后才显示 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批环节</span>
                    <div className="field-value">
                      <WorkflowStatus
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                      />
                    </div>
                  </li>
                )}
                {/* 审批流按钮 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批操作</span>
                    <div className="field-value">
                      <WorkflowButtons
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                        onChange={() => {
                          self.getDetail();
                        }}
                      />
                    </div>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>

        {/* 单头自定义 */}
        <div className="m-details-item">
          <HeadCustField
            fieldSetting={fieldSetting}
            detail={detail}
            setDetail={setDetail}
            isPurchase={self.isPurchase}
          ></HeadCustField>
        </div>

        {/*付款明细 */}
        {!Util.isEmpty(detail.lineList) && (
          <div className="m-details-item">
            <div className="details-item-title">
              <label>付款明细</label>
            </div>

            <div className="details-item-content">
              {detail.lineList.map((item, index) => (
                <div className="content-line line-list-item" key={index}>
                  <div className="line-list-item-title">
                    <span>项次 {index + 1}</span>
                  </div>

                  <ul className="field-list">
                    <li>
                      <span className="field-label">计划单号</span>
                      <div className="field-value">{item.pmpXkNo}</div>
                    </li>
                    <li>
                      <span className="field-label">来源单号</span>
                      <div className="field-value">{item.sourceXkNo}</div>
                    </li>
                    <li>
                      <span className="field-label">来源单类型</span>
                      <div className="field-value">{item.sourceTypeName}</div>
                    </li>
                    <li>
                      <span className="field-label">申请付款金额</span>
                      <div className="field-value">
                        {formatNumber(item.applyTaxAmount, decimalPlace.AMOUNT)}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">付款完成金额</span>
                      <div className="field-value">
                        {formatNumber(item.realTaxAmount, decimalPlace.AMOUNT)}
                      </div>
                    </li>
                  </ul>
                  {/* 单身自定义字段 */}
                  <BodydCustField
                    fieldSetting={fieldSetting}
                    line={item}
                    isPurchase={self.isPurchase}
                  ></BodydCustField>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {User.checkAuth('10040306') &&
            [1, 4].includes(detail.status) &&
            workflow.data &&
            workflow.data['receipt_audit_2'].complete && (
              <Button
                type="default"
                onClick={() => {
                  audit();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                审核
              </Button>
            )}
          {User.checkAuth('10040306') &&
            [1].includes(detail.status) &&
            workflow.data &&
            workflow.data['receipt_audit_2'].complete && (
              <Button
                type="default"
                onClick={() => {
                  auditReturn();
                }}
                className="m-flex-item u-btn u-btn_warn"
              >
                退回
              </Button>
            )}
        </div>
      )}

      <Modal></Modal>
      {
        // 附件查看
        Array.isArray(fileList) && fileList.length > 0 && (
          <Download fileList={fileList} />
        )
      }
    </div>
  );
}

PaymentDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentDetail);
